export default {
    phoneNumber: /[0-9()\-.\s]+/g,
}

export const extract = (str: string | null, pattern: RegExp): string | null => {
    if (!str)
        return str;

    const result = Array.from(str.matchAll(pattern)) || [];
    return result.join("");
}